// Define the plugin display information type
interface PluginDisplayInfo {
  label: string;
  logo: string;
  shortLabel: string;
}

export const PLUGIN_DISPLAY_MAP_KEYS = new Set([
  'aws',
  'awscur',
  'azure',
  'backstage',
  'cloudflare',
  'crowdstrike',
  'digitalocean',
  'entraid',
  'gcp',
  'github',
  'k8s',
  'oracle',
  'pagerduty',
  'palo-alto-cortex',
  'sentinelone',
  'wiz',
]);

export const PLUGIN_DISPLAY_MAP: Record<string, PluginDisplayInfo> = {
  aws: {
    label: 'Amazon Web Services',
    logo: 'aws.svg',
    shortLabel: 'AWS',
  },
  awscur: {
    label: 'Amazon Web Services Cost and Usage Reports',
    logo: 'aws.svg',
    shortLabel: 'AWS CUR',
  },
  azure: {
    label: 'Microsoft Azure',
    logo: 'azure.svg',
    shortLabel: 'Azure',
  },
  backstage: {
    label: 'Backstage',
    logo: 'backstage.svg',
    shortLabel: 'Backstage',
  },
  cloudflare: {
    label: 'Cloudflare',
    logo: 'cloudflare.svg',
    shortLabel: 'Cloudflare',
  },
  crowdstrike: {
    label: 'CrowdStrike',
    logo: 'crowdstrike.png',
    shortLabel: 'CrowdStrike',
  },
  digitalocean: {
    label: 'DigitalOcean',
    logo: 'digitalocean.svg',
    shortLabel: 'DigitalOcean',
  },
  entraid: {
    label: 'Entra ID',
    logo: 'entraid.png',
    shortLabel: 'Entra ID',
  },
  gcp: {
    label: 'Google Cloud Platform',
    logo: 'gcp.svg',
    shortLabel: 'GCP',
  },
  github: {
    label: 'GitHub',
    logo: 'github.svg',
    shortLabel: 'GitHub',
  },
  k8s: {
    label: 'Kubernetes',
    logo: 'kubernetes.svg',
    shortLabel: 'Kubernetes',
  },
  oracle: {
    label: 'Oracle Cloud',
    logo: 'oracle.svg',
    shortLabel: 'Oracle',
  },
  pagerduty: {
    label: 'PagerDuty',
    logo: 'pagerduty.svg',
    shortLabel: 'PagerDuty',
  },
  'palo-alto-cortex': {
    label: 'Palo Alto Networks Cortex',
    logo: 'paloaltonetworks.png',
    shortLabel: 'PAN Cortex',
  },
  sentinelone: {
    label: 'SentinelOne',
    logo: 'sentinelone.png',
    shortLabel: 'SentinelOne',
  },
  wiz: {
    label: 'Wiz',
    logo: 'wiz.svg',
    shortLabel: 'Wiz',
  },
};
